import { render } from "./PersonTransfer.vue?vue&type=template&id=3c872eb2&scoped=true"
import script from "./PersonTransfer.vue?vue&type=script&lang=js"
export * from "./PersonTransfer.vue?vue&type=script&lang=js"

import "./PersonTransfer.vue?vue&type=style&index=0&id=3c872eb2&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c872eb2"]])

export default __exports__